var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isOK&&_vm.list.length==0)?_c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":_vm.sourc2+'mini/default/car_none2.png'}}),_c('div',[_vm._v(_vm._s(_vm.no_data))])]):_vm._e(),_c('div',{staticClass:"h120"})])
}
var staticRenderFns = []

export { render, staticRenderFns }